import styled, { css } from 'styled-components';

const eventItemsBorderBottom = css `
  border-bottom: 1px solid ${props => props.theme.colors.darkGray}80;
  padding-bottom: 0.625rem;
  margin-bottom: 0.625rem;
`;
const eventItemsBorderBottomReset = css `
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
`;
const StyledEventsContainer = styled.div `
  .csGWrap {
    background-color: transparent;

    .csCol {
      .cs_head {
        display: none;
      }

      .csEventAll {
        display: flex;
        flex-direction: column;
        position: relative;
        background-color: transparent;
        height: auto !important;

        > section {
          box-sizing: initial;
          ${eventItemsBorderBottom}
        }

        > div {
          display: flex;
          flex-direction: column;
          padding: 0 !important;
        }

        .eventInfo {
          color: ${props => props.theme.colors.textColor};
          padding: 0;
        }

        .csErap {
          box-shadow: none;
          ${eventItemsBorderBottom}

          &:last-of-type {
            ${eventItemsBorderBottomReset}
          }

          a {
            display: flex;
            gap: 1rem;
          }
        }

        .csTime,
        .csDate {
          color: ${props => props.theme.colors.mutedTextColor};
          font-size: ${props => props.theme.typography.text.micro.fontSize};
        }

        .csImg,
        .csNoImg {
          width: 80px;
        }

        .cs_h2 {
          font-weight: ${props => props.theme.typography.fontWeight.regular};
        }

        .csVenue,
        .citySt {
          color: ${props => props.theme.colors.mutedTextColor};
          font-size: ${props => props.theme.typography.text.micro.fontSize};
          font-weight: ${props => props.theme.typography.fontWeight.medium};
          opacity: 0.8;
        }

        .hooper-list {
          .hooper-slide {
            box-shadow: none !important;
            border: 0 !important;
          }

          .hooper-navigation {
            .icon {
              path:last-of-type {
                fill: ${props => props.theme.colors.textColor};
              }
            }
          }

          .csSpon {
            background-color: ${props => props.theme.colors.skyBlue};
          }
        }
      }

      .csBottomLinks {
        display: flex;
        background-color: transparent;
        padding: 1rem 0 0;
        justify-content: space-between;
        flex-direction: column;
        gap: 0.5rem;

        .csBtn {
          margin: 0;

          a {
            display: inline-block;
            box-sizing: border-box;
          }

          &:first-of-type {
            a {
              width: 100%;
              background-color: ${props => props.theme.colors.skyBlue} !important;
              padding: 0.5rem 2rem;
              font-size: ${props => props.theme.typography.text.micro.fontSize};
              font-weight: ${props => props.theme.typography.fontWeight.medium};
              transition-property: background-color;
              transition-duration: ${props => props.theme.animation.duration.quick1};
              transition-timing-function: ${props => props.theme.animation.easing.expressive.standard};

              @media (pointer: fine) {
                &:hover {
                  background-color: ${props => props.theme.colors.skyBlueShade} !important;
                }
              }
            }
          }

          &:last-of-type {
            a {
              background-color: transparent !important;
              padding: 0;
              font-weight: ${props => props.theme.typography.fontWeight.medium};
              color: ${props => props.theme.colors.slate} !important;

              &::before {
                content: '+';
                display: inline-block;
                color: ${props => props.theme.colors.skyBlue};
                margin-right: 0.25rem;
              }
            }
          }
        }
      }

      @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
        .csEventAll {
          > section {
            position: absolute;
            width: calc(50% - 1.5rem);
            top: 0;
            left: 0;
            ${eventItemsBorderBottomReset}
          }

          > div {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-gap: 1.5rem;

            &:first-of-type {
              &::before {
                content: '';
                display: block;
              }
            }
          }

          .csErap {
            ${eventItemsBorderBottomReset}
          }
        }

        .csBottomLinks {
          padding: 1.5rem 0 0;
          flex-direction: row;

          .csBtn:first-of-type {
            a {
              padding: 0.6rem 2rem;
              font-size: ${props => props.theme.typography.headings.h5.fontSize};
            }
          }
        }
      }

      @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
        .csEventAll {
          > section {
            width: calc(33.33% - (3.75rem * 2 / 3));
          }

          > div {
            grid-template-columns: repeat(3, 1fr);
            grid-gap: 2.5rem 3.75rem;
          }
        }

        .csBottomLinks {
          padding: 2.5rem 0 0;
        }
      }
    }

    .csMon {
      display: none;
    }
  }
`;

export { StyledEventsContainer };
//# sourceMappingURL=CitysparkEvents.styles.mjs.map
